<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">Edit Affiliations</h4>
</div>
<div class="modal-body">
    <form [formGroup]="affiliationForm">
        <fieldset>
            <div class="row">
                <div class="col-sm-3 mvd_form-group">
                    <label>Affiliation Type</label>
                    <select required class="mvd_form-control" formControlName="affiliationTypeId">
                        <option *ngFor="let affiliationType of customerAffiliationTypes" value="{{affiliationType.id}}">{{affiliationType.displayValue}}</option>
                    </select>
                </div>
                <div class="col-sm-3 mvd_form-group">
                    <label>Effective Date</label>
                    <p-calendar formControlName="effectiveDate" [showIcon]="true"></p-calendar>
                    <div class="mvd_alert__validation">
                        <div class="mvd_alert__rule" *ngIf="affiliationForm.get('effectiveDate').hasError('required')">Effective date is required</div>
                        <div class="mvd_alert__rule" *ngIf="affiliationForm.hasError('startAfterEndDate')">Effective date cannot be after End date</div>
                    </div>
                </div>
                <div class="col-sm-3 mvd_form-group">
                    <label>End Date</label>
                    <p-calendar formControlName="endDate" [showIcon]="true"></p-calendar>
                </div>
            </div>

            <ng-container *ngIf="affiliationForm.get('customerAffiliationRoleTypeIds')" formArrayName="customerAffiliationRoleTypeIds">
                <div class="row" *ngFor="let affiliate of affiliates; let i = index">
                    <div class="col-sm-3 mvd_form-group">
                        <label *ngIf="affiliate.isPrimary">Customer</label>
                        <label *ngIf="!affiliate.isPrimary">Affiliate</label>
                        <input class="mvd_form-control" disabled="" type="text" value="{{affiliate.customerName}}">
                    </div>
                    <div class="col-sm-4 mvd_form-group" *ngIf="!roleTypesLoading">
                        <label>Role Type</label>
                        <select class="mvd_form-control" [formControlName]="i" (change)="onRoleTypeChange(+$event.target.value, i)">
                            <option *ngFor="let role of customerAffiliationRoleTypes[affiliate.customerTypeId]" value="{{role.id}}">{{role.customerAffiliationRoleTypeDisplayValue}}</option>
                        </select>
                    </div>
                    <div class="col-sm-1 mvd_form-group" *ngIf="!affiliate.isPrimary">
                        <label>&nbsp;</label>
                        <a class="icon--delete" title="Delete Affiliate" href="javascript:void(0)" (click)="deleteAffiliate(i)"></a>
                    </div>
                </div>
            </ng-container>

            <div class="row">
                <div class="col-sm-12 mvd_form-group">
                    <a class="icon--add" href="javascript:void(0)" (click)="addAffiliate()"> Add Customer</a>
                    <h2 class="mvd_alert--label" *ngIf="showPrimaryValidationError">Only 1 Role Type of {{primaryAffiliationRoleType}} is allowed.</h2>
                </div>
            </div>

        </fieldset>
    </form>
</div>
<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--default" type="button" (click)="cancel()">Cancel</button>
        <button class="btn--primary" type="submit" [disabled]="!affiliationForm.valid" (click)="saveAffiliation()">Save</button>
    </div>
</div>